import { useState } from "react";
import { useLoginContext } from "../../../App";
import { fetchWidgetData, fetchWidgetPublicData } from "../../../services/b2b-reporting-apiServices";
import { useQuery } from "@tanstack/react-query";
import useDecryptData from "../../b2b-common/hooks/useDecryptData";
import { objectHash } from "../../b2b-common/helpers";

const useGettingWidgetData = (widget, atPublicDashboard = false, password = null) => {

    const { loginData } = useLoginContext();
    const [loading, setLoading] = useState(false);
    const { decryptData } = useDecryptData();

    const getWidgetData = async () => {
        // getting data via the b2b-reporting API
        try {
            setLoading(true);
            const widgetDataResponse = await fetchWidgetData(loginData.accessToken, widget.organizationUUID, widget.dashboardId, widget.widgetId);
            return widgetDataResponse;
        } catch (error) {
            console.error('Error fetching widget data', error);
        }
        finally {
            setLoading(false);
        }
    };

    const getWidgetPublicData = async () => {
        try {
            setLoading(true);
            const widgetDataResponseEncrypted = await fetchWidgetPublicData(widget.organizationUUID, widget.dashboardId, widget.widgetId, password);
            const widgetDataResponse = decryptData(widgetDataResponseEncrypted);
            // console.log('widgetDataResponse (public): ', widgetDataResponse);
            return widgetDataResponse;
        } catch (error) {
            console.error('Error fetching widget data', error);
        } finally {
            setLoading(false);
        }
    };

    const { data: widgetData } = useQuery({
        queryKey: ['widgetData', objectHash(widget), atPublicDashboard],
        queryFn: () => (atPublicDashboard ? getWidgetPublicData() : getWidgetData()),
        enabled: !!widget.dashboardId && !!widget.widgetId,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchIntervalInBackground: false,
        retry: 0,
        staleTime: 1000 * 60 * 20, 
        cacheTime: 1000 * 60 * 20, 
    });
    
    return { widgetData, loading };
}

export default useGettingWidgetData;